interface Props {
  message: string;
  onRetry: () => void;
}

export default function ErrorState({ message, onRetry }: Props) {
  return (
    <div
      role="alert"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 0', gap: '16px', textAlign: 'center' }}
    >
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="var(--asneris-error)" strokeWidth="2" />
        <line x1="12" y1="8" x2="12" y2="12" stroke="var(--asneris-error)" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16" r="1" fill="var(--asneris-error)" />
      </svg>
      <p style={{ margin: 0, fontSize: '15px', color: 'var(--asneris-text)' }}>
        {message || 'Something went wrong. Please try again.'}
      </p>
      <button className="asneris-btn asneris-btn-secondary asneris-btn-sm" type="button" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
